import { Navigate, Outlet } from 'react-router-dom';
import { useTaAccess } from '@/hooks/useTalentAcquisition';
import { WinclapLoader } from '@/components/ui/winclap-loader';

/**
 * Gate de People → Talent Acquisition. El acceso lo resuelve el governance
 * TA_GOVERNANCE (Ignacio Bresso + admins; viewers por persona o team): sin el
 * gate, quien no tiene acceso entraría y vería el dashboard vacío — el
 * FORBIDDEN silencioso que prohíbe la política de roles del repo.
 * Desde el 25/09/2026 también entra quien puede pedir una búsqueda (`canIntake`:
 * líderes con reportes directos) — la página le muestra solo "Nueva búsqueda".
 * Desde el 07/10/2026, también el Hiring Manager o Bar Raiser de una guía de
 * entrevista (`canInterview`): abre Guías de entrevista y ve solo las suyas.
 */
export function TaProtectedRoute() {
  const { data: access, isLoading } = useTaAccess();
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <WinclapLoader size={48} className="text-foreground/25" />
      </div>
    );
  }
  if (!access?.canView && !access?.canIntake && !access?.canInterview) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
